import { NotificationIcon } from "vega-icons";

import { m } from "@vega-core/paraglide/messages";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";
import { formatBadgeCount } from "@vega-core/utils/formatBadgeCount";

import { useNotificationCenter } from "../NotificationCenter.context";

import { NotificationCenterTrigger } from "./NotificationCenterTrigger";

type Props = {
  className?: string;
  ariaLabel?: string;
};

export const NotificationCenterBellTrigger = ({
  className,
  ariaLabel,
}: Props) => {
  const { unreadCount } = useNotificationCenter();
  const hasUnread = unreadCount > 0;
  const displayCount = formatBadgeCount(unreadCount);

  const resolvedAriaLabel =
    ariaLabel ??
    (hasUnread
      ? m.notificationCenter_triggerUnreadAriaLabel({ count: unreadCount })
      : m.notificationCenter_triggerAriaLabel());

  return (
    <NotificationCenterTrigger>
      <button
        aria-label={resolvedAriaLabel}
        className={cnTwMerge(
          "relative inline-flex items-center justify-center h-10 w-10 rounded-default text-text/primary hover:bg-background/secondary defaultTransition focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-default",
          className,
        )}
        data-testid="notification-center-bell-trigger"
        type="button"
      >
        <NotificationIcon aria-hidden="true" className="h-6 w-6" />
        {hasUnread ? (
          <span
            aria-hidden="true"
            className="absolute -top-1 -right-1 inline-flex items-center justify-center min-w-[1.125rem] h-[1.125rem] px-1 rounded-full bg-brand-default text-text/on-brand body-extra-small-semibold leading-none font-semibold ring-2 ring-background/primary"
            data-testid="notification-center-unread-count"
          >
            {displayCount}
          </span>
        ) : null}
      </button>
    </NotificationCenterTrigger>
  );
};
